import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const comment = css`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const header = css`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const avatar = css``;

export const info = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const date = css`
  color: ${theme.colors.peoople['gris-medio']};
`;

export const nickname = css`
  font-weight: 600;
`;

export const like = css`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const message = css`
  font-size: 16px;
  font-weight: 300;
`;
